<script lang="ts">
    import { MapLegendLayers, MapLegendLayersActive, MapLegendStoreX } from './MapLegendStore';
    import MapLegendItem from './MapLegendItem.svelte';
    import type { MapLayerOneType } from '../../utilities/MapLayer/MapLayerApi';
    import { blur } from 'svelte/transition';

    let visibleLayers: MapLayerOneType[] = [];

    $: {
        visibleLayers = $MapLegendLayers.filter(layer => $MapLegendLayersActive.includes(layer.id));
    }
</script>

{#if visibleLayers.length > 0}
    <div
        class="map_legend_container"
        style="left: {$MapLegendStoreX}px; "
        in:blur={{ duration: 500, delay: 0 }}
        out:blur={{ duration: 500, delay: 0 }}
    >
        <!--  (layer.id) -->
        {#each visibleLayers as layer}
            <MapLegendItem {layer} />
        {/each}
    </div>
{/if}

<style>
    .map_legend_container {
        border-radius: 5px;
        box-shadow: rgba(0, 0, 0, 0.4) 1px 1px 12px 0px;
        width: 235px;
        background-color: rgba(255, 255, 255, 0.9);
        z-index: 100;
        /*border: 1px solid rgb(222, 222, 222);*/
        visibility: visible;
        position: absolute;
        bottom: 36px;
        padding: 0 12px;
    }
</style>
